import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5 11.731H3c-.6 0-1-.391-1-.978v-7.82c0-.587.4-.978 1-.978h3.2c.6 0 1-.39 1-.977S6.8 0 6.2 0H3C1.3 0 0 1.27 0 2.933v7.82c0 1.662 1.3 2.933 3 2.933h2c.6 0 1-.39 1-.977s-.4-.978-1-.978M17 0h-2c-.6 0-1 .391-1 .978 0 .586.4.977 1 .977h2c.6 0 1 .391 1 .978v7.82c0 .587-.4.978-1 .978h-3.2c-.6 0-1 .391-1 .978 0 .586.4.977 1 .977H17c1.7 0 3-1.27 3-2.933v-7.82C20 1.271 18.7 0 17 0m4 4.888c-.6 0-1 .39-1 .977v1.956c0 .586.4.977 1 .977s1-.39 1-.977V5.865c0-.586-.4-.977-1-.977m-7.1 1.466c-.2-.293-.5-.489-.9-.489H8.9l3-4.3c.3-.49.2-1.076-.3-1.37-.5-.293-1.1-.195-1.4.294l-4 5.865c-.2.294-.2.685 0 .978.1.293.4.489.8.489h4.1l-3 4.301c-.3.489-.2 1.075.3 1.369.2.097.4.195.6.195.3 0 .6-.195.8-.39l4-5.866c.2-.392.3-.685.1-1.076"
    }, null, -1)
  ]))]))
}
export default { render: render }